import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { TreatmentPlanningService } from '../../treatment-planning/treatment-planning.service';
import { TreatmentReportComponent } from '../../treatment-planning/treatment-report/treatment-report.component';

@Component({
  selector: 'app-patient-portal-treatments',
  templateUrl: './patient-portal-treatments.component.html',
  styleUrls: ['./patient-portal-treatments.component.css']
})
export class PatientPortalTreatmentsComponent implements OnInit {

  isLoading: boolean = false;

  patientInformation: any;
  PatientId: string;
  dataPatient: any;

  currentTreatmentPlan: any;
  treatmentPlans: any[] = [];

  constructor(
    private treatmentPlanService: TreatmentPlanningService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.patientInformation = JSON.parse(localStorage.getItem('storedPatient'));
    this.PatientId = this.patientInformation.authdata.userid;
    this.init();
  }

  init() {

    this.isLoading = true;
    this.getTreatmentPlansForPatient(this.PatientId)
      .then((results: any[]) => {

        this.treatmentPlans = results;

        let promises = this.treatmentPlans.map(treatmentPlan => {
          return this.setupTreatmentPlans(treatmentPlan);
        });

        Promise.all(promises).then((results: any[]) => {
          this.isLoading = false;
        }, err => {
          console.log(err);
          this.isLoading = false;
        });

      }, err => {
        console.log(err);
        this.isLoading = false;
      });

  }

  getTreatmentPlansForPatient(patientId) {
    return this.treatmentPlanService.getTreatmentPlanList(patientId).toPromise();
  }

  setupTreatmentPlans(treatmentPlan) {
    let promise = new Promise((resolve, reject) => {
      this.onSelectedTreatmentPlanChange(treatmentPlan, treatmentPlan.TreatmentPlanningID)
        .then(treatmentPlanOptions => {
          var isApproved = false;
          treatmentPlan.treatmentPlanOptions = treatmentPlanOptions;

          treatmentPlan.treatmentPlanOptions.forEach(option => {
            var notApproved = option.Procedures.find(proc => { return !proc.isApproved });
            if (!notApproved) {
              isApproved = true;
            }
          });

          treatmentPlan.approved = isApproved;

          resolve(treatmentPlan);
        }, err => {
          console.log(err);
        });
    });
    return promise;
  }

  async getOptionsForPlan(treatmentPlan) {

    this.onSelectedTreatmentPlanChange(treatmentPlan, treatmentPlan.TreatmentPlanningID)
      .then(treatmentPlanOptions => {
        //this.openReportForSelectedOption(treatmentPlanOptions);
      }, err => {
        console.log(err);
      });

  }

  onSelectedTreatmentPlanChange(treatmentPlan, treatmentPlanId) {
    // executing both requests at the same time to reduce loading times

    let promise = new Promise((resolve, reject) => {

     // this.isLoading = true;

      let promises: any[] = [
        this.treatmentPlanService.getTreatmentPlan(treatmentPlanId).toPromise(),
        this.treatmentPlanService.getTreatmentPlanProcedure(treatmentPlanId).toPromise(),
      ];

      Promise.all(promises).then((results: any[]) => {

        var tretmentPlanData = results[0];
        var tretmentPlanProcData = results[1];

        tretmentPlanData.forEach((treatmentPlan) => {
          treatmentPlan.Procedures =
            tretmentPlanProcData.filter(procedure => {
              return (procedure.TreatmentPlanningID === treatmentPlan.TreatmentPlanningID)
            });
        });

        treatmentPlan = tretmentPlanData;
        //this.tabPanelTreatmentPlanSelectedIndex = 0;

        this.calculateInsuranceAndPatientCost(treatmentPlan);

        //this.isLoading = false;

        resolve(treatmentPlan);

      }, err => {
        reject(err);
        console.log(err);
        //this.isLoading = false;
        //this.createAlertMessage('Error', 'Something went wrong', 5000);
      });

    });
    return promise;

  }

  calculateInsuranceAndPatientCost(treatmentPlan) {
    console.log('calculate the insurance cost for this treatment plan');
    console.log(treatmentPlan);

    var coverageTypePercent: string = '00000048-1000-0000-0000-000000000001';
    var coverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';

    treatmentPlan.forEach((planOption: any) => {
      planOption.Procedures.forEach((planProcedure: any) => {

        var procedureFee = planProcedure.Fee;
        if (procedureFee) {
          if (planProcedure.enumFeeCoverageCalcTypeId === coverageTypePercent) {
            var coverage = procedureFee * (planProcedure.CoveragePCT / 100);
            var patientDuePrice = procedureFee - coverage;
            planProcedure.PriceTotalDueByInsurance = coverage;
            planProcedure.PriceDueByPatient = patientDuePrice;
          } else {
            var patientDuePrice = procedureFee - planProcedure.CoverageAmount;
            planProcedure.PriceTotalDueByInsurance = planProcedure.CoverageAmount;
            planProcedure.PriceDueByPatient = patientDuePrice;
          }
        }

      });
    });

  }

  openReportForSelectedOption(treatmentPlan) {
    var treatmentPlanOptions = treatmentPlan.treatmentPlanOptions;

    //treatmentPlan
    const dialogRef = this.dialog.open(TreatmentReportComponent, {
      width: '90%',
      height: '90%',
      disableClose: true,
      data: {
        treatmentPlanOptions: treatmentPlanOptions,
        readyOnly: false,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.init();
      }

    }, err => {
    });
  }

  createAlertMessage(type: string, message: string, duration: number = 3000) {
    this.snackBar.open(message, type, {
      duration: duration,
      verticalPosition: "top"
    });
  }

}
